module.exports = __webpack_public_path__ + "img/market.820e9046.png";